var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-builder form-inline"},[_c('query-builder-group',{attrs:{"customItems":_vm.customItems,"slots":_vm.slots,"index":0,"query":_vm.query,"ruleTypes":_vm.ruleTypes,"rules":_vm.mergedRules,"maxDepth":3,"depth":_vm.depth,"type":"query-builder-group"},on:{"update:query":function($event){_vm.query=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }